import { Reveal, Overline } from "./motion";
import { useT } from "@/i18n/LangContext";

export default function Services() {
  const t = useT();

  return (
    <section id="services" data-testid="services-section" className="py-20 md:py-40">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-14 grid grid-cols-1 gap-8 md:mb-20 md:grid-cols-12">
          <Reveal className="md:col-span-5">
            <Overline testId="services-overline">{t.services.overline}</Overline>
            <h2
              data-testid="services-heading"
              className="mt-6 font-serif text-4xl font-light leading-tight tracking-tight text-ink md:text-5xl"
            >
              {t.services.h1}
              <br />
              {t.services.h2pre}{" "}
              <span className="relative inline-block">
                {t.services.h2clear}
                <span
                  className="absolute -bottom-1 left-0 h-[3px] w-full bg-bee"
                  aria-hidden="true"
                />
              </span>{" "}
              {t.services.h2post}
            </h2>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-5 md:col-start-8 md:self-end">
            <p className="max-w-md text-base font-light leading-relaxed text-ink/85 md:text-lg">
              {t.services.intro}
            </p>
          </Reveal>
        </div>

        {t.services.groups.map((group) => (
          <div key={group.id} className="mb-14 last:mb-0 md:mb-16">
            <Reveal>
              <div
                className="mb-8 flex items-center gap-4"
                data-testid={`service-group-${group.id}`}
              >
                <span className="h-[3px] w-8 rounded-full bg-bee" aria-hidden="true" />
                <p className="text-xs font-medium uppercase tracking-[0.25em] text-ink/75">
                  {group.label}
                </p>
              </div>
            </Reveal>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-8">
              {group.items.map((s, i) => (
                <Reveal key={s.n} delay={0.08 * i} className={s.span}>
                  <div
                    data-testid={`service-card-${s.n}`}
                    className={`flex h-full flex-col justify-between border p-6 md:p-10 ${
                      s.featured ? "border-ink/15 bg-lav" : "border-lavline bg-paper"
                    }`}
                  >
                    <span className="font-serif text-5xl font-medium text-ink md:text-6xl">
                      {s.n}
                    </span>
                    <div className="mt-10 md:mt-16">
                      <h3 className="font-serif text-2xl font-normal tracking-tight text-ink md:text-3xl">
                        {s.title}
                      </h3>
                      <p className="mt-4 max-w-xl text-base font-light leading-relaxed text-ink/85">
                        {s.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
